module.exports = __webpack_public_path__ + "static/media/fly0000.2bc42b5e.webp";